//Router
PJQ.routers = {};

PJQ.routers.BaseRouter = Backbone.Router.extend({
	routes: {
		"": "empty"
	},
	initialize: function () {
		//Add all assigned routes
		_.each(PJQ.app.routes, function (route) {
			this.route(route.route, route.name, route.callback);
		}, this);
	},
	empty: function () {
		if (PJQ.app.module === PJQ.constants.modules.APP) {
			if (PJQ.app.session != null && !PJQ.app.session.isLoggedIn()) {
				//If the user isn't logged in, force nav to sign in
				this.signInNavigate();
			}
			else {
				//try to match routes with a parameter
				let matchedRoute = false;
				_.each(_.filter(PJQ.app.routes, function (paramRoute) {
					return _.size(paramRoute.route) > 0;
				}), function (paramRoute) {
					if (!matchedRoute && _.indexOf(paramRoute.route, '?') !== -1 && typeof paramRoute.callback === 'function') {
						let paramValues = [],
							hasAllParams = true;
						_.each(paramRoute.route.replace('?', '').split('&'), function (param) {
							if (hasAllParams) {
								let paramVal = PJQ.helpers.urlHelpers.getQueryParam(param.split('=:')[0], false,paramRoute.retainParameterValueCase === true);
								if (paramVal && _.size(paramVal) > 0) {
									paramValues.push(paramVal);
								}
								else {
									hasAllParams = false;
								}
							}
						});
						if (hasAllParams) {
							paramRoute.callback(...paramValues);
							matchedRoute = true;
						}
					}
				});

				if (!matchedRoute) {
					if (PJQ.app.session.hasFeature('projects')) {
						this.navigate('projects', {
							trigger: true,
							replace: true
						});
					}
					else if(PJQ.app.session.get('portalId') !== PJQ.constants.panteraPortalId || (PJQ.app.session.user != null && PJQ.app.session.user.get('companyType') === "SUB")) {
						this.navigate('projectinvites', {
							trigger: true,
							replace: true
						});
					}
					else{
						this.navigate('settings', {
							trigger: true,
							replace: true
						});
					}
				}
			}
		}
		else {
			let matchedRoute = false;
			if (typeof PJQ.app.oldRoutes === 'object') {
				_.each(_.filter(PJQ.app.oldRoutes, function (oldRoute) {
					return _.size(oldRoute.route) > 0;
				}), function (oldRoute) {
					_.find(oldRoute.route.split(' '), function (param) {
						let paramVal = PJQ.helpers.urlHelpers.getQueryParam(param.replace('?', ''));
						if (paramVal && _.size(paramVal) > 0 && typeof oldRoute.callback === 'function') {
							oldRoute.callback(paramVal);
							matchedRoute = true;
						}
					});
				});
			}
			if (!matchedRoute) {
				let defaultRoute = _.find(PJQ.app.oldRoutes, function (oldRoute) {
					return oldRoute.name === 'default';
				});
				if (defaultRoute && typeof defaultRoute.callback === 'function') {
					//If there is a default route overriding this from old modules, route to that
					defaultRoute.callback();
				}
				else if (_.size(PJQ.app.readyEvents) > 0) {
					//This function calls all bound functions to ready (added by attachReadyEvent)
					//These are only added by old modules
					//All new modules should use routes
					//This uses an array so multiple ready events can be attached (for different modules)
					//There should ideally only ever be one function in the array
					// However we don't want a situation where one module overrides another so we do it this way
					_.each(PJQ.app.readyEvents, function (func) {
						if (typeof func === 'function')
							func();
					});
				}
			}
		}
	}
	,
	noAuthRoutes: [
		'invoiceguestlink',
		'signin',
		'signup',
		'signuptrial',
		'sharephotos',
		'sharedrawings',
		'sharefiles',
		'scheduleshare',
		'resetpassword',
		'prequal',
		'register'
	],
	signInNavigate: function (options = {}) {
		if (options != null) {
			if (options.cacheRoute) {
				PJQ.app.router.signInCache = '#' + this.getCurrentRoute();
			}
		}

		$('.skin-header').hide();
		PJQ.app.$el.css('top', 0);
		if (PJQ.app.portal != null && _.size(PJQ.app.portal.pages) > 0) {
			let portalSignInRoute = _.findWhere(PJQ.app.portal.pages, {route: 'signin'});
			if (portalSignInRoute != null) {
				this.navigate('p/' + portalSignInRoute.route, {
					trigger: true,
					replace: true
				});
				return;
			}
		}

		this.navigate('signin', {
			trigger: true,
			replace: true
		});
	},
	routeToRoot: function () {
		PJQ.app.router.navigate('/', {
			trigger: true
		});
	},
	execute: function (callback, args, name) {
		if (typeof ga === 'function') {
			ga('send', 'pageview', {
				'page': location.pathname + location.search + location.hash
			});
		}

		if (!PJQ.app.view) {
			PJQ.app.view = new PJQ.views.AppView(PJQ.app.$el);
		}

		if (PJQ.app.view.photoViewer) {
			let triggerRoute = PJQ.app.view.photoViewer.options.triggerRoute;
			PJQ.app.view.photoViewer.hide();
			if (triggerRoute) {
				Backbone.Router.prototype.execute.call(this, callback, args, name);
				return;
			}
		}
		let accessKey = PJQ.helpers.urlHelpers.getQueryParam('accessKey');
		if (_.size(accessKey) > 0) {
			PJQ.app.session.set('accessKey', accessKey);
			if (_.size(window.location.hash) > 0 && window.location.hash.indexOf('?') > -1) {
				let hashArr = window.location.hash.split('?'),
					posStatus = hashArr[_.size(hashArr) - 1].toUpperCase(),
					resQuery = 'RESPONSE=';
				if (posStatus.indexOf(resQuery) > -1) {
					PJQ.app.session.set('bidStatus', posStatus.replace(resQuery, ''));
				}
			}
		}

		let $menuItems = $('.pt-menu-item');
		if (_.size($menuItems) > 0) {
			let utId;
			if (PJQ.app.session.get('ownsPortal') && PJQ.app.session.user != null) {
				utId = PJQ.app.session.user.get('userTypeId');
			}
			else if (PJQ.app.session.contact != null) {
				utId = PJQ.app.session.contact.get('userTypeId');
			}
			else {
				utId = null;
			}
			$menuItems.each(function () {
				let $menuitem = $(this);
				let allowedUtString = $menuitem.data('userTypes');
				if (_.size(allowedUtString) > 0) {
					if (_.find(allowedUtString.split(','), function (allowedUt) {
						return parseInt(allowedUt) === utId;
					})) {
						$(this).removeClass('hidden');
					}
					else {
						$(this).addClass('hidden');
					}
				}
			});
		}

		let contactGuid = PJQ.helpers.urlHelpers.getQueryParam('cg');
		if (_.size(contactGuid) > 0) {
			PJQ.app.session.set('contactGuid', contactGuid);
		}

		if (_.size(window.staticRoute) > 0 && name !== window.staticRoute) {
			this.navigate(window.staticRoute, {
				trigger: true,
				replace: true
			});
			return;
		}

		//If this is the single page module and the user isn't signed in
		//We force navigation to the sign in route
		let isPortalRoute = name.indexOf('portal_') !== -1,
			$header = $('.skin-header'),
			$appMain = PJQ.app.$el;
		if (isPortalRoute && PJQ.app.session.isLoggedIn()) {
			this.navigate('', {
				trigger: true,
				replace: true
			});
			return;
		}
		else if (!isPortalRoute && PJQ.app.module === PJQ.constants.modules.APP && !PJQ.app.session.isLoggedIn() && this.noAuthRoutes.indexOf(name.toLowerCase()) === -1) {
			// if this is the root route and there is a portal root route, navigate to it
			if (name === 'empty' && PJQ.app.portal != null && _.size(PJQ.app.portal.pages) > 0) {
				let rootRoute = _.findWhere(PJQ.app.portal.pages, {isRoot: true});
				if (rootRoute != null) {
					this.navigate('/p/' + rootRoute.route, {
						trigger: true,
						replace: true
					});
					return;
				}
			}

			if (PJQ.app.session.isPanteraPortal() && (_.size(accessKey) > 0 || _.size(contactGuid) > 0)
				&& (PJQ.app.session.contact == null || !(PJQ.app.session.contact.get('userId') > 0))) {
				$appMain.css('top', 0);
				this.navigate('signup', {
					trigger: true,
					replace: true
				});
				return;
			}
			else if (_.size(accessKey) === 0 && _.size(contactGuid) === 0) {
				this.signInNavigate({
					cacheRoute: true
				});
				return;
			}
			else {
				$header.show();
			}
		}
		else if (isPortalRoute || name === 'signin' || name === 'signup') {
			$appMain.css('top', 0);
			$header.hide();
			$appMain.scrollTop(0);

			//this is a sign in or sign up route, make sure the session is fetched
			if (!PJQ.app.session.isFetched) {
				PJQ.app.session.fetch();
			}
		}
		else {
			$header.show();
			$appMain.css('top', $header.height());

			//this is an app route, make sure the session is fetched
			if (!PJQ.app.session.isFetched) {
				PJQ.app.session.fetch();
			}
		}

		let foundRoute = _.findWhere(PJQ.app.routes, {name: name});
		if (foundRoute != null) {
			if (typeof foundRoute.title === 'function') {
				document.title = foundRoute.title();
			}
			else if (_.size(foundRoute.title)) {
				document.title = foundRoute.title;
			}
		}

		Backbone.Router.prototype.execute.call(this, callback, args, name);
	}
	,
	getCurrentRoute: function () {
		return window.location.hash.replace('#', '');
	}
});